import React, { useEffect } from "react";
import { FaPen } from "react-icons/fa";

const InventoryModal = ({
    showModal,
    setShowModal,
    editData,
    setEditData,
    handleSubmit,
    loading,
    isEdit
}) => {

    const handleClose = () => setShowModal(false);

    const handleChange = (field, value) => {
        setEditData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // ESC close
    useEffect(() => {
        const esc = (e) => e.key === "Escape" && handleClose();
        document.addEventListener("keydown", esc);
        return () => document.removeEventListener("keydown", esc);
    }, []);

    if (!showModal) return null;

    return (
        <div className="oms-overlay">
            <div className="oms-modal">

                {/* HEADER */}
                <div className="oms-modal-head">
                    <span className="oms-modal-title">
                        <FaPen size={16} className="me-2" />
                        {isEdit ? "Edit Inventory" : "Add Inventory"}
                    </span>
                    <button className="oms-icon-btn" onClick={handleClose}>✕</button>
                </div>

                {/* BODY */}
                <div className="oms-modal-body">
                    {/* <div className="oms-form-grid"> */}
                    <div className="">

                        {/* FIRST NAME */}
                        <div className="oms-form-group mb-3">
                            <label className="oms-form-label">Product</label>
                            <input
                                className="oms-form-input"
                                value={editData.product_name || ""}
                                onChange={(e) => handleChange("product_name", e.target.value)}
                            />
                        </div>

                        {/* LAST NAME */}
                        <div className="oms-form-group mb-3">
                            <label className="oms-form-label">Quantity</label>
                            <input
                                className="oms-form-input"
                                value={editData.quantity || ""}
                                onChange={(e) => handleChange("quantity", e.target.value)}
                            />
                        </div>

                        {/* USERNAME */}
                        <div className="oms-form-group mb-3">
                            <label className="oms-form-label">Price</label>
                            <input
                                type="number"
                                className="oms-form-input"
                                value={editData.price || ""}
                                onChange={(e) => handleChange("price", e.target.value)}
                            />
                        </div>



                    </div>
                </div>

                {/* FOOTER */}
                <div className="oms-modal-foot">
                    <button
                        className="oms-btn oms-btn-ghost"
                        onClick={handleClose}
                    >
                        Cancel
                    </button>

                    <button
                        className="oms-btn oms-btn-primary"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? "Saving..." : isEdit ? "Update Inventory" : "Add Inventory"}
                    </button>
                </div>

            </div>
        </div>
    );
};

export default InventoryModal;